import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import Axios from "./../../../../utils/api/axiosConf";
import { url } from "../../../../utils/api/api";
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import BUTTON from "./../../../../components/buttons/button";
import TEXTROW from "../../../../components/textRow";
import LOADING from "../../../../components/loading/loading";
import INPUT from "./../../../../components/input/input";
import UPLOAD from "./../../../../components/uoload/upload";
import { Uploder } from "../../../../utils/utils";
import noPhoto from './../../../../assets/images/noPhoto.jpeg';
import { color } from "./../../../../utils/themes/color";
import recycleImg from "./../../../../assets/images/recycleBin.jpg";
import { Pagination } from 'antd';




export default function Withdraw(props) {

    const userId = props.userId
    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false, 4: false });
    const [user, setUser] = useState({});
    const [data, setData] = useState([]);
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 });
    const [inventory, setInventory] = useState({});
    const [updator, setUpdator] = useState(1)

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}withdraw/user-withdraw-list/${userId}?pageNumber=${page.current}&limit=${page.pageSize}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setData(response.data.docs)
                    setPage({
                        ...page,
                        current: response.data.page,
                        total: response.data.totalDocs

                    })
                    setLoading({ ...loading, 1: false })
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 1: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [page.current, updator])

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}withdraw/get-user-wallet-amount?userId=${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setInventory(response.data)
                    setLoading({ ...loading, 1: false })
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 1: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])


    const updateWithdraw = () => {

        if (user.amount != "" && user.amount != null && user.amount != undefined && user.sheba != "" && user.sheba != null && user.sheba != undefined) {

            var x = {
                amount: user.amount,
                sheba: user.sheba,
                userId: userId
            }

            setLoading({ ...loading, 1: true })
            Axios.post(`${url}withdraw/insert-withdraw-req-for-user`, x)
                .then(async (response) => {

                    if (response.status === 200 || response.status === 201) {
                        setUpdator(updator + 1)
                        GreenNotif(response.message);
                        setLoading({ ...loading, 1: false })

                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 1: false })
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 1: false })
                });

        } else {
            RedNotif("مقدار و شبا نمیتواند خالی باشد")
        }
    }


    const deleteWithdraw = (item) => {
        var x = [];

        data.filter(function (obj) {
            if (obj.amount !== item.amount) {
                x.push(obj)
            }
        });

        setData(x)

    }

    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <p>اطلاعات برداشت را وارد نمایید:</p>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ justifyContent: 'left', alignItems: 'left', display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p style={{ color: color.primary, fontSize: "20px", padding: '4px' }}>موجودی:</p>
                            <p style={{ fontSize: "20px", padding: '4px' }}>{inventory.amount}تومان</p>
                        </div>
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>مقدار:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <INPUT
                            placeholder="مبلغ را به تومان وارد کنید"
                            i={(e) => setUser({ ...user, "amount": e })}
                            value={user.amount != undefined && user.amount != null && user.amount != "0" ? user.amount : ""}
                        />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>شماره شبا:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <INPUT
                            placeholder="شماره شبای 24 رقمی خود را وارد کنید"
                            i={(e) => setUser({ ...user, "sheba": e })}
                            value={user.sheba != undefined && user.sheba != null && user.sheba != "0" ? user.sheba : ""}
                        />
                    </Col>
                </Row>

                <Row gutter={[8, 16]} style={{ marginTop: '32px' }} >
                    {data.map((item, index) =>
                        <Col offset={1} span={6} key={index} xxl={6} xl={6} lg={6} md={6} sm={6} style={{ border: `1px solid ${color.primary}`, background: "white", height: "120px" }}>

                            <Row style={{ margin: '18px' }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <p style={{ color: color.primary, fontSize: "20px" }}>{item.amount}</p>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '18px' }}>
                                <Col xxl={22} xl={22} lg={22} md={22} sm={22} style={{ marginBottom: '28px' }}>
                                    <p style={{ fontSize: "12px" }}>{item.sheba}</p>
                                </Col>
                                <Col xxl={2} xl={2} lg={2} md={2} sm={2} style={{ marginBottom: '28px' }}>
                                    <img src={recycleImg} style={{ width: "50%", cursor: "pointer" }} onClick={() => deleteWithdraw(item)} />
                                </Col>
                            </Row>

                        </Col>
                    )}

                </Row>

                <Row style={{ marginTop: '68px' }} gutter={20}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <Pagination defaultCurrent={page.current} total={page.total} />

                    </Col>
                </Row>

                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON
                            loading={loading[2]}
                            event={(e) => {
                                updateWithdraw()
                                setUser({ ...user, "amount": "", "sheba": "" })
                            }}
                            text={"افزودن اطلاعات برداشت"}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(6)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>


            </>
        )
    }

}